import fetch, { fetchJson } from 'utils/fetch';

export const getAllWorkers = () => fetchJson('/pco-manager/workers.json');

export const getVacationDetail = vacationId =>
  fetchJson(`/pco-manager/vacations/${vacationId}`);

export const saveVacationDetail = (workerId, json) =>
  fetch(`/pco-manager/users/${workerId}/vacations`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });

export const updateVacationDetail = (vacationId, json) =>
  fetch(`/pco-manager/vacations/${vacationId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(json),
  });



// WEBPACK FOOTER //
// ./src/modules/saas/users/api/index.js